var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 7.25C4.73438 7.25 5.25 7.76562 5.25 8.375V11.375C5.25 12.0078 4.73438 12.5 4.125 12.5H1.125C0.492188 12.5 0 12.0078 0 11.375V8.375C0 7.76562 0.492188 7.25 1.125 7.25H4.125ZM4.125 11.375V8.375H1.125V11.375H4.125ZM4.125 0.5C4.73438 0.5 5.25 1.01562 5.25 1.625V4.625C5.25 5.25781 4.73438 5.75 4.125 5.75H1.125C0.492188 5.75 0 5.25781 0 4.625V1.625C0 1.01562 0.492188 0.5 1.125 0.5H4.125ZM4.125 4.625V1.625H1.125V4.625H4.125ZM10.875 7.25C11.4844 7.25 12 7.76562 12 8.375V11.375C12 12.0078 11.4844 12.5 10.875 12.5H7.875C7.24219 12.5 6.75 12.0078 6.75 11.375V8.375C6.75 7.76562 7.24219 7.25 7.875 7.25H10.875ZM10.875 11.375V8.375H7.875V11.375H10.875ZM10.875 0.5C11.4844 0.5 12 1.01562 12 1.625V4.625C12 5.25781 11.4844 5.75 10.875 5.75H7.875C7.24219 5.75 6.75 5.25781 6.75 4.625V1.625C6.75 1.01562 7.24219 0.5 7.875 0.5H10.875ZM10.875 4.625V1.625H7.875V4.625H10.875Z",
    fill: "#CCC7D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2);
export default __webpack_public_path__ + "static/media/grid-2.3750524c431d1c0c56e2a1d34cb329f4.svg";
export { ForwardRef as ReactComponent };